import * as types from '../constants/surveyConstants';
import * as api from '../../api/api';
import * as coreTypes from '../../core/constants/coreConstants';
import _ from 'underscore';
import { browserHistory } from 'react-router';

export function getSurvey(surveyId, jobId) {
	return function (dispatch) {
		dispatch(changeUIState());
		
		api.get("merchantsurvey/" + surveyId + "/" + jobId)
			.then(function (survey) {
				if (!survey.isCompleted) {
					dispatch(getSurveyQuestionsSuccess(survey.questions));

					if (survey.response)
						dispatch(setSurveyResponses(survey.response));
				}
				else
					dispatch(submitSurveySuccess(survey.isCompleted));
			})
			.catch(function () {
				browserHistory.push('/contactus/errorDetailed/100');
			});
	};
}

export function getSurveyQuestionsSuccess(questions) {
	return {
		type: types.GET_SURVEY_QUESTIONS_SUCCESS,
		questions: questions
	};
}

export function submitSurvey(response) {
	return function (dispatch) {
		dispatch({ type: types.SUBMIT_SURVEY });

		api.post("merchantsurvey", response)
			.then(function () {
				dispatch(getSurvey(response.merchantSurveyId, response.jobId));
			})
			.catch(function () {
				browserHistory.push('/contactus/errorDetailed/101');
			});
	};
}

export function submitSurveySuccess(isComplete) {
	return {
		type: types.SUBMIT_SURVEY_SUCCESS,
		isComplete: isComplete
	};
}

export function getFSPProfile(jobId) {
	return function (dispatch) {
		dispatch({ type: types.GET_FSP_PROFILE });

		api.get("fspprofile/".concat(jobId))
			.then(function (response) {
				dispatch(getFSPProfileSuccess(response));
			})
			.catch(function () {
				browserHistory.push('/contactus/errorDetailed/102');
			});
	};
}

export function getFSPProfileSuccess(profile) {
	return {
		type: types.GET_FSP_PROFILE_SUCCESS,
		profile: profile
	};
}

export function setSurveyResponses(responses) {
	return {
		type: types.SET_SURVEY_RESPONSES,
		responses: _.object(_.map(responses.split("|"), function (r) { return r.split("^"); }))
	};
}

export function changeUIState() {
	return {
		type: coreTypes.UPDATE_UI_STATE,
		response: coreTypes.UI_STATES.SURVEY
	};
}


// WEBPACK FOOTER //
// ./app/survey/actions/surveyActions.js